import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { LoadingService } from 'src/app/core/services/loader.service';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { LoginComponent } from '../login/login.component';
import { UsersService } from '../services/users.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { registerLocaleData } from '@angular/common';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit, OnDestroy {
  submitted = false;
  applicationForm: FormGroup;
  emailSubject = new Subject();
  status = true;
  loginText = 'Login';
  hide = true;
  public token;
  userData;

  constructor(
    public dialogRef: MatDialogRef<ForgotPasswordComponent>,
    private formBuilder: FormBuilder,
    private loadingService: LoadingService,
    private userService: UsersService,
    public dialog: MatDialog,
    private auth: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.applicationForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });

    this.emailSubject
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((value) => {
        this.checkEmail();
      });
  }
  ngOnDestroy(): void {
    this.emailSubject?.unsubscribe();
  }

  onSubmit() {
    this.status = false;
    this.submitted = true;
    if (this.applicationForm.invalid) {
      return;
    }
    this.loginText = 'Please wait..';
    this.loadingService.startLoading();
    console.log(this.applicationForm.getRawValue());
    this.userService.login(this.applicationForm.getRawValue()).subscribe(
      (response) => {
        if (response) {
          this.status = false;
          this.setToken(response.data.accessToken);
          this.token = response.data.accessToken;
          this.setImage(response.data.image);
          this.userData = this.auth.getDecodedUserAccessToken();
          this.auth.autoLogout();
          this.loadingService.stopLoading();
          this.auth.fetchingData.next(this.auth.getCurrentUrl());
        }
      },
      (err) => {
        console.log('error', err);
        if (err.error.message === 'check email') {
          this.openConfirmationPopup(
            this.applicationForm.get('username').value
          );
        } else {
          this.auth.showSnackBarMsg('Username and password is incorrect.');
        }
        this.loadingService.stopLoading();
        this.loginText = 'Login';
        this.submitted = false;
      }
    );
  }
  openConfirmationPopup(email) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      width: '500px',
      data: { email, emailExist: true, headerData: 'Create Password!' },
    });
  }
  onEmailKeyup() {
    const searchText = this.applicationForm.get('username').value;
    this.emailSubject?.next(searchText);
  }
  checkEmail() {
    // this.loadingService.startLoading();
    const email = this.applicationForm.get('username').value;
    if (email && this.validateEmail(email)) {
      this.userService.getUserByEmail(email).subscribe(
        (response) => {
          console.log(response);
          if (response.data == 'check email') {
            this.openConfirmationPopup(email);
          }
          // this.loadingService.stopLoading()
        },
        (err) => {
          // this.loadingService.stopLoading()
          console.log('error', err);
        }
      );
    }
  }
  validateEmail(email) {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }

  setToken(response) {
    this.auth.setLoginUserDetail(response);
    this.auth.isLoggedIn = true;
  }
  setImage(response) {
    this.auth.setLoginUserImage(response);
  }
  get applicationF() {
    return this.applicationForm.controls;
  }

  forgotPassword() {
    const dialogRef = this.dialog.open(ForgotPasswordComponent, {
      width: '500px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result == 'backToLogin') {
          //this.openDialog('LOGIN TO YOUR ACCOUNT');
        }
      }
    });
  }
  onRegister() {
    // this.router.navigate(['/']);
    this.auth.gotoUrl('/');
  }
}
